import { render, staticRenderFns } from "./scanRebateDetail.vue?vue&type=template&id=5f72e468"
import script from "./scanRebateDetail.vue?vue&type=script&lang=js"
export * from "./scanRebateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports